import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import {
    MetaFields
} from '../../Constants';

import { 
    onMetaFieldChange
} from '../../actions/AppActions';

import {
    useDebounce
} from '../../Utils';

const MetaFieldsContainer = ({ onChange, officeAddressIdx, metaData }) => {

    const [patientName, setPatientName] = useState(metaData[MetaFields.PatientName.id] || "");
    const [claimNumber, setClaimNumber] = useState(metaData[MetaFields.ClaimNumber.id] || "");
    const [insuranceCompany, setInsuranceCompany] = useState(metaData[MetaFields.InsuranceCompany.id] || "");
    const [office, setOffice] = useState(!isNaN(officeAddressIdx) ? officeAddressIdx : "");

    const debouncedPatientName = useDebounce(patientName, 500);
    const debouncedClaimNumber = useDebounce(claimNumber, 1000);
    const debouncedInsuranceCompany = useDebounce(insuranceCompany, 500);
    const debouncedOffice = useDebounce(office, 250);

    useEffect(
        () => {
            if([debouncedPatientName, debouncedClaimNumber, 
                debouncedInsuranceCompany]
                .some(x => x)) {

                onChange(MetaFields.PatientName.id, debouncedPatientName);
                onChange(MetaFields.ClaimNumber.id, debouncedClaimNumber);
                onChange(MetaFields.InsuranceCompany.id, debouncedInsuranceCompany);
            }

            if (debouncedOffice) {
                // Debouncing office has to be separate because of how
                // ... the weird placeholder works for dropdown lists
                onChange(MetaFields.OfficeAddress.id, debouncedOffice);
            }
        },
        [debouncedPatientName, debouncedClaimNumber, debouncedInsuranceCompany, debouncedOffice]
    );

    return (
        <form className="meta-fields-container" id="testform">
            { /* Input for Patient Name */ }
            <input
                type={MetaFields.PatientName.type}
                placeholder={MetaFields.PatientName.placeholder}
                onChange={e => setPatientName(e.target.value)}
            ></input>

            { /* Input for Claim Number */ }
            <input
                type={MetaFields.ClaimNumber.type}
                placeholder={MetaFields.ClaimNumber.placeholder}
                onChange={e => setClaimNumber(e.target.value)}
            ></input>

            { /* Input for Insurance Company */ }
            <input
                type={MetaFields.InsuranceCompany.type}
                placeholder={MetaFields.InsuranceCompany.placeholder}
                onChange={e => setInsuranceCompany(e.target.value)}
            ></input>

            { /* Dropdown for offices */ }
            <select
                name="office"
                onChange={e => setOffice(e.target.value)}
                value={!isNaN(officeAddressIdx) ? officeAddressIdx : ""} // this is required for a placeholder dropdown
            >
                <option value="" disabled>Select an Office...</option>
                {MetaFields.OfficeAddress.options.map((optionVal, idx) =>
                    (<option key={idx} value={idx}>{optionVal.name}</option>))}
            </select>
        </form>
    )
}



const mapStateToProps = state => {
    const strOfficeAddressIdx = state.interestForm.metaData[MetaFields.OfficeAddress.id]
    const numOfficeAddressId = (strOfficeAddressIdx === null) ? NaN : Number(strOfficeAddressIdx)
    return {
        officeAddressIdx: numOfficeAddressId,
        metaData: state.interestForm.metaData
    }
}

const mapDispatchToProps = dispatch => ({
    onChange: (field, value) => dispatch(onMetaFieldChange(field, value))
})

export default connect(
    mapStateToProps, mapDispatchToProps
)(MetaFieldsContainer);